'use client';
import {useEffect} from 'react';

export function PageMotion(){
  useEffect(()=>{
    const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
    if(preference.matches||!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('motion-visible');observer.unobserve(entry.target)}
      });
    },{threshold:0.08});
    const elements=document.querySelectorAll('.capability,.section-heading,.journey>div,.industry-row>a,.cta,.page-content .panel');
    elements.forEach((element,i)=>{
      (element as HTMLElement).style.setProperty('--reveal-delay',`${i%3*65}ms`);
      element.classList.add('motion-ready');observer.observe(element);
    });
    const clear=()=>{observer.disconnect();elements.forEach(element=>element.classList.remove('motion-ready'))};
    preference.addEventListener('change',clear);
    return()=>{clear();preference.removeEventListener('change',clear)};
  },[]);
  return null;
}
